import React from "react";
import DatePicker from "react-datepicker";

export const CustomInvoice = ({
  msg,
  okButtonShow,
  okButtonText,
  okAction,
  cancelButtonShow,
  cancelButtonText,
  closeAction,
  changeInvoiceNo,
}) => {
  let styles = {
    marginBottom: "20px",
  };
  //Model shows the limit exceed the limit
  return (
    <div className="modal-overlay">
      <div className="popup_inner" style={{width:"34%"}}>
        <div className="close_popup">
          <button onClick={closeAction}>X</button>
        </div>
        <div className="popup_content">
          <div className="popup_txt">
            <div style={styles}>{msg}</div>
            <div style={{ marginLeft: "10px" }}>
              <input
                type="text"
                style={{ border: "1px solid" }}
                // value={custominvoice}
                onChange={changeInvoiceNo}
              />
            </div>
          </div>
          <div className="popup_footer">
            {cancelButtonShow && (
              <button onClick={closeAction}>{cancelButtonText}</button>
            )}
            {okButtonShow && <button onClick={okAction}>{okButtonText}</button>}
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/getCustomInvoicejsx.jsx